
export const tabLink = ["All","website", "Landing", "Designs"];
export const tabData = [
  {
    type: "website",
    tabTitle: "Websites",
    title: "FITNESS EXERCISE APP",
    tags: ["HTML5", "JAVASCRIPT", "REACTJS","Material-UI","ExerciseDB API"],
    image:"https://serving.photos.photobox.com/29663636e87bad2f38d4c29e5a1c9832e0ad8adc0af3562bf14dbf977d03ffaeab4bdf66.jpg",
    source: "https://exercise-nandi.netlify.app/",
    description:
      "A exercise web app with functionality to choose exercise categories Using React js.Used ExerciseDB API to fetch various exercises data.Used YouTube API to display particular exercise related videos from youtube.  Used Matrial-UI for design",
  },
  {
    type: "Landing",
    tabTitle: "Landing Pages",
    title: "IMDB CLONE",
    tags: ["HTML5", "CSS3", "JAVASCRIPT", "REACTJS","OMDB API"],
    image:
      "https://serving.photos.photobox.com/91037558d6493d7e8413eea37b7b4b5b1c794f1dd191e3bdd5a556dc4e6f1b9aee86f5c9.jpg",
    source: "https://subhajitnandi2002.github.io/Moviereactwebsite/",
    description:
      "IMDB clone based on React js.Used OMDB API to fetch various data's related to movies.Used React Router for Dynamic Routing.Used CSS for design.",
  },
  {
    type: "Designs",
    title: "FOOD RECIPE APP",
    tabTitle: "UI/UX Designs",
    tags: ["HTML5", "JAVASCRIPT", "REACTJS","SASS CSS","Edamam API"],     
    image:"https://serving.photos.photobox.com/45279163c5627175ab7b1fe32c34367165b5fad07c7babe8bf7d96fce1155c083137ba39.jpg",
    source: "https://subhajitnandi2002.github.io/recipereactproject/",
    description:
      "A recipe web app with many functionality base on React js.Used Edamam API to fetch various data's related to Recipe.Used SASS CSS for design",
  },

];
